import { render } from "./EditBranch.vue?vue&type=template&id=7c776f61&scoped=true"
import script from "./EditBranch.vue?vue&type=script&lang=js"
export * from "./EditBranch.vue?vue&type=script&lang=js"

import "./EditBranch.vue?vue&type=style&index=0&id=7c776f61&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7c776f61"

export default script